import { QueryClientProvider } from "react-query";
import { PostHogProvider } from "posthog-js/react";
import { ToastProvider } from "@beachfront/ui";

import { queryClient } from "../../query-client";
import { ThemeProvider } from "../../context";
import posthog from "../../utils/posthog";

import GlobalStyle from "./global-style";
import AppRouter from "./app-router";
import PosthogIdentify from "./posthog-identify";

function App() {
    return (
        <ThemeProvider>
            <GlobalStyle />
            <ToastProvider>
                <QueryClientProvider client={queryClient}>
                    <PostHogProvider client={posthog}>
                        <PosthogIdentify />
                        <AppRouter />
                    </PostHogProvider>
                </QueryClientProvider>
            </ToastProvider>
        </ThemeProvider>
    );
}

export default App;
